import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsArrowLeftNormalXsmall = React.forwardRef(
  ({ color, size, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      {...props}
    >
      <path d="M11 15a.5.5 0 01-.35-.15l-6.5-6.5a.5.5 0 010-.71l6.5-6.5a.5.5 0 11.71.71L5.21 8l6.15 6.15A.5.5 0 0111 15z" />
    </svg>
  )
);
SvgActionsArrowLeftNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16
};
SvgActionsArrowLeftNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};
export default SvgActionsArrowLeftNormalXsmall;
